import React from 'react'
import Header from '../Navbar/page'
import { useNavigate } from 'react-router-dom'

function GameOver() {
    const navigate=useNavigate()

    const navnextlevel=()=>{  
     navigate("/")
    }

  return (

    <>
    <Header />
    <div className="wrapper overflow-hidden ">
        {/* <!-- Top content --> */}

        <div className="container position-relative">
          <form
            className="multisteps_form bg-white position-relative overflow-hidden height-auto"
            id="wizard"
            method="POST"
            action=""
          >
            {/* <!------------------------- Step-1 -----------------------------> */}

            <div className=" right-answer">
              <div className="popup-score">
                <h3 className="popup-head text-center">Game over</h3>
               

                {/* <div className="pass_check bg-success text-white">
                 {resultAnswer >= 3 ? "Great job! You passed with an impressive score – well done!" : "Good try! You passed with a score, but you can do better next time."} 
                </div>
                <div className="" style={{color:"red",fontWeight: '600', paddingTop:"10px"}}>
                 {resultAnswer >= 3 ? "" : "You can't move to the next level. your score is less than 60 points"} 
                </div> */}
              </div>


              {/* {resultAnswer >= 3 ? ( */}
                 <div className="form_btn">
                 <a >
                   <button
                     type="button"
                     className="next_btn rounded-pill text-uppercase text-white Hide-15"
                     id="nextBtn"
                     onClick={navnextlevel}
                   >
                     Home page
                   </button>
                 </a>
               </div>
              {/* ): (
                <>
              <div className="form_btn">
                <a>
                  <button
                    type="button"
                    className="next_btn rounded-pill text-uppercase text-white Hide-15"
                    id="nextBtn"
                   onClick={Perviewpagefunction}
                  >
                    New Game
                  </button>
                </a>
              </div>
              </>
              )} */}


              {/* <div className="form_btn">
                <a>
                  <button
                    type="button"
                    className="next_btn rounded-pill text-uppercase text-white Hide-15"
                    id="nextBtn"
                    onclick="nextPrev(1)"
                  >
                    New Game
                  </button>
                </a>
              </div> */}
              


            </div>

            {/* <!---------- Form Button ----------> */}
          </form>
        </div>
      </div>
    </>
  )
}

export default GameOver